import { render, staticRenderFns } from "./ruleConfigTable.vue?vue&type=template&id=fd92c67c&"
import script from "./ruleConfigTable.vue?vue&type=script&lang=js&"
export * from "./ruleConfigTable.vue?vue&type=script&lang=js&"
import style0 from "./ruleConfigTable.vue?vue&type=style&index=0&rel=stylesheet%2Fscss&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports